import { type ReactNode, useId } from 'react';
import { cn } from '@/shared/lib';

export interface CardBlockProps {
  title: ReactNode;
  note?: ReactNode;
  /** Элементы справа в шапке блока (кнопки правки, «Только чтение»). */
  actions?: ReactNode;
  footer?: ReactNode;
  className?: string;
  children: ReactNode;
}

/**
 * Блок карточки (README §5): белая карточка radius 18, border line-strong; шапка 38, padding 0 14,
 * заголовок Display 19 600, пояснение 12 ink-400; подвал — surface-sunken, 12 ink-600.
 * Общий для виджета карточки и фич, которые рисуют свой блок (например, профиль автора).
 */
export function CardBlock({ title, note, actions, footer, className, children }: CardBlockProps) {
  const titleId = useId();
  return (
    <section
      aria-labelledby={titleId}
      className={cn(
        'overflow-hidden rounded-18 border border-line-strong bg-paper-pure',
        className,
      )}
    >
      <div className="flex h-38 items-center gap-10 border-b border-line-hair px-14">
        <h2 id={titleId} className="font-display text-[19px] whitespace-nowrap text-ink-900">
          {title}
        </h2>
        {note ? <span className="min-w-0 truncate text-[12px] text-ink-400">{note}</span> : null}
        <span className="flex-1" />
        {actions}
      </div>
      {children}
      {footer ? (
        <div className="border-t border-line-hair bg-surface-sunken px-14 py-10">
          <span className="text-[12px] leading-[20px] text-ink-600">{footer}</span>
        </div>
      ) : null}
    </section>
  );
}
